module.exports = __webpack_public_path__ + "img/ai-logo-black.1a2c9ba3.png";